// SNS 공유 기능을 위한 유틸리티 함수들

/**
 * 클립보드에 텍스트 복사
 */
export const copyToClipboard = async text => {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
    } else {
      // 폴백 메서드 (구형 브라우저 지원)
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.opacity = '0';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
    }
    return true;
  } catch (error) {
    console.error('클립보드 복사 실패:', error);
    return false;
  }
};

/**
 * 카카오톡 공유 (카카오 JavaScript SDK 필요)
 */
export const shareToKakao = ({ title, url, imageUrl }) => {
  console.log('카카오톡 공유 시작:', { title, url, imageUrl });
  if (!window.Kakao) {
    console.error('카카오 SDK가 로드되지 않았습니다.');
    throw new Error('카카오톡 공유를 위해 카카오 SDK가 필요합니다.');
  }

  if (!window.Kakao.isInitialized()) {
    console.error('카카오 SDK가 초기화되지 않았습니다.');
    throw new Error('카카오톡 공유를 위해 카카오 SDK 초기화가 필요합니다.');
  }

  // 기본 이미지 URL 설정
  const defaultImageUrl = 'https://www.sweduhub.or.kr/images/meta-img.png';

  window.Kakao.Share.sendDefault({
    objectType: 'feed',
    content: {
      title: title || 'SW미래채움',
      imageUrl: imageUrl || defaultImageUrl,
      link: {
        mobileWebUrl: url,
        webUrl: url
      }
    },
    buttons: [
      {
        title: '웹으로 보기',
        link: {
          mobileWebUrl: url,
          webUrl: url
        }
      }
    ]
  });
};

/**
 * 페이스북 공유
 */
export const shareToFacebook = ({ title, url }) => {
  const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&title=${encodeURIComponent(title)}`;
  window.open(shareUrl, '_blank', 'width=600,height=400');
};

/**
 * 네이버 블로그 공유
 */
export const shareToNaver = ({ title, url }) => {
  const shareUrl = `https://share.naver.com/web/shareView?url=${encodeURIComponent(url)}&title=${encodeURIComponent(title)}`;
  window.open(shareUrl, '_blank', 'width=600,height=400');
};

/**
 * 네이버 밴드 공유
 */
export const shareToNaverBand = ({ title, url }) => {
  const shareUrl = `https://band.us/plugin/share?body=${encodeURIComponent(title)}%0A${encodeURIComponent(url)}&route=${encodeURIComponent(url)}`;
  window.open(shareUrl, '_blank', 'width=600,height=400');
};

/**
 * 메인 공유 함수
 */
export const shareToSNS = (platform, data) => {
  const { title, url, description, imageUrl } = data;

  switch (platform) {
    case 'kakao':
      shareToKakao({ title, url, description, imageUrl });
      break;
    case 'facebook':
      shareToFacebook({ url });
      break;
    case 'naver':
      shareToNaver({ title, url });
      break;
    case 'band':
      shareToNaverBand({ title, url });
      break;
    default:
      console.error('지원하지 않는 플랫폼입니다:', platform);
  }
};

/**
 * 현재 페이지 정보 가져오기
 */
export const getCurrentPageInfo = () => {
  return {
    title: document.title,
    url: window.location.href,
    description: document.querySelector('meta[name="description"]')?.content || '',
    imageUrl: document.querySelector('meta[property="og:image"]')?.content || ''
  };
};
